/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react';
import 'moment/locale/pt';
import { Box, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';

import InputMask from "react-input-mask";
import { removeCpfMask } from '../../../../utils/functions';
import { enqueueSnackbar } from 'notistack';
import { GetFetch, PostFetch } from '../../../../services/apiBase';

export default function NewBrancheModal({ onEdit, editPromoCode, onClose, getList }) {

  const user = JSON.parse(localStorage.getItem('user'))
  const [load, setLoad] = useState(false);
  const [errorValidation, setErrorValidation] = useState({});

  const [newCad, setNewCad] = useState({})
  const [cities, setCities] = useState({})
  const [birthCities, setBirthCities] = useState({})

  const [birthCity, setBirthCity] = useState({})
  const [city, setCity] = useState({})
  const [birthState, setBirthState] = useState({})
  const [state, setState] = useState({})

  const [document, setDocument] = useState('');
  const [documentType, setDocumentType] = useState('cpf');

  const handleDocumentTypeChange = (e) => {
    setDocumentType(e.target.value);
    setDocument('');
  };

  const uf = [
    { label: "AC", value: "AC" },
    { label: "AL", value: "AL" },
    { label: "AP", value: "AP" },
    { label: "AM", value: "AM" },
    { label: "BA", value: "BA" },
    { label: "CE", value: "CE" },
    { label: "DF", value: "DF" },
    { label: "ES", value: "ES" },
    { label: "GO", value: "GO" },
    { label: "MA", value: "MA" },
    { label: "MT", value: "MT" },
    { label: "MS", value: "MS" },
    { label: "MG", value: "MG" },
    { label: "PA", value: "PA" },
    { label: "PB", value: "PB" },
    { label: "PR", value: "PR" },
    { label: "PE", value: "PE" },
    { label: "PI", value: "PI" },
    { label: "RJ", value: "RJ" },
    { label: "RN", value: "RN" },
    { label: "RS", value: "RS" },
    { label: "RO", value: "RO" },
    { label: "RR", value: "RR" },
    { label: "SC", value: "SC" },
    { label: "SP", value: "SP" },
    { label: "SE", value: "SE" },
    { label: "TO", value: "TO" }
  ]

  const handleOnChange = (e) => {
    let key = e.target.id
    let value = e.target.value
    setNewCad({ ...newCad, [key]: value })
  }

  const handleOnCloseModal = () => {
    onClose()
  }

  const handleSelectUF = async (e, id) => {
    const response = await GetFetch(`/subscription/listCity?code_uf=${e.target.value}`);
    if (id === "birth_city_id") {
      setBirthCities(response.data)
      setBirthState(e.target.value)
    } else if (id === "city_id") {
      setCities(response.data)
      setState(e.target.value)
    }
  }

  const handleOnSelectCity = (e, id) => {
    setNewCad({ ...newCad, [id]: e.target.value })
    if (id === 'birth_city_id') {
      setErrorValidation({ ...errorValidation, 'birthCity': false })
      setBirthCity(e.target.value)
    }
    if (id === 'city_id') {
      setErrorValidation({ ...errorValidation, 'city': false })
      setCity(e.target.value)
    }
  }

  const handleSubmit = async (e) => {
    try {
      if (!newCad.birth_city_id && !newCad.city_id) {
        setErrorValidation({ ...errorValidation, 'birthCity': true, 'city': true })
        return
      } else if (!newCad.birth_city_id) {
        setErrorValidation({ ...errorValidation, 'birthCity': true })
        setLoad(false)
        return
      } else if (!newCad.city_id) {
        setErrorValidation({ ...errorValidation, 'city': true })
        setLoad(false)
        return
      } else {
        setErrorValidation({})
      }
      setLoad(true)
      if (!newCad.register_number) {
        newCad.register_number = "Não informado"
      }

      newCad.username = user.username
      newCad.owner_document = removeCpfMask(document)

      await PostFetch(`/financial/createFarmHouse`, newCad);
      enqueueSnackbar('Nova filial cadastrada com sucesso!', { variant: 'success' });
      handleOnCloseModal()
      getList()
      setLoad(false)
    } catch (error) {
      enqueueSnackbar('Erro ao cadastrar nova filial', { variant: 'error' });
      handleOnCloseModal()
      setLoad(false)
    }
  }

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Cadastrar nova filial
        </Typography>
      </Box>

      <Box sx={{
        marginTop: '16px',
        marginBottom: '16px',
        marginRight: '32px',
        width: 800,
        minWidth: 800,
        maxHeight: '80%',
        height: '90%',
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
        gap: 2
      }}>

        <Typography variant="h6" component="h2">
          Informações da filial
        </Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth>
            <TextField
              id={`priority`}
              label="Prioridade"
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              id={`name`}
              label="Nome"
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth>
            <TextField
              id={`county`}
              label="Comarca"
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              id={`register`}
              label="Matrícula"
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth>
            <TextField
              id={`register_number`}
              label="Registro de imóveis"
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              id={`catle_farmhouse`}
              label="Capacidade"
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth>
            <InputLabel id="state">Estado</InputLabel>
            <Select
              labelId="state"
              id="state"
              name="state"
              label="Estado"
              value={state}
              onChange={e => handleSelectUF(e, 'city_id')}
            >
              {uf.map(uf => (
                <MenuItem value={uf.value}>{uf.label}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel id="city">Cidade</InputLabel>
            <Select
              labelId="city"
              id="city"
              name="city"
              label="Cidade"
              value={city}
              error={errorValidation?.city}
              onChange={e => handleOnSelectCity(e, "city_id")}
            >
              {cities && cities.length > 0 ? (cities.map(city => (
                <MenuItem value={city.value}>{city.name_city}</MenuItem>
              )))
                : <MenuItem value={''}>{'Carregando...'}</MenuItem>}
            </Select>
          </FormControl>
        </Box>

        <Typography variant="h6" component="h2">
          Informações do proprietário
        </Typography>

        <FormControl fullWidth>
          <TextField
            id={`owner`}
            label="Nome"
            onChange={(event) => {
              handleOnChange(event);
            }}
          />
        </FormControl>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl sx={{ minWidth: 140 }}>
            <InputLabel id="document-type-label">Tipo</InputLabel>
            <Select
              labelId="document-type-label"
              id="document-type"
              value={documentType}
              label="Tipo"
              onChange={handleDocumentTypeChange}
            >
              <MenuItem value="cpf">CPF</MenuItem>
              <MenuItem value="cnpj">CNPJ</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth>
            {documentType === 'cpf' ? (
              <InputMask
                mask="999.999.999-99"
                maskChar=" "
                value={document}
                onChange={(event) => setDocument(event.target.value)}
              >
                {() =>
                  <TextField
                    error={errorValidation?.cpf}
                    required
                    label="CPF"
                  />
                }
              </InputMask>
            ) : (
              <InputMask
                mask="99.999.999/9999-99"
                maskChar=" "
                value={document}
                onChange={(event) => setDocument(event.target.value)}
              >
                {() =>
                  <TextField
                    error={errorValidation?.cpf}
                    required
                    label="CNPJ"
                  />
                }
              </InputMask>
            )}
          </FormControl>

          <FormControl fullWidth>
            <TextField
              id={`owner_nationality`}
              label="Nacionalidade"
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth>
            <TextField
              id={`onwer_marital`}
              label="Estado civil"
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              id={`profession`}
              label="Profissão"
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>
        </Box>

        <FormControl fullWidth>
          <TextField
            id={`address`}
            label="Endereço"
            onChange={(event) => {
              handleOnChange(event);
            }}
          />
        </FormControl>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth>
            <InputLabel id="birth_state">Estado</InputLabel>
            <Select
              labelId="birth_state"
              id="birth_state"
              name="birth_state"
              label="Estado"
              value={birthState}
              onChange={e => handleSelectUF(e, "birth_city_id")}
            >
              {uf.map(uf => (
                <MenuItem value={uf.value}>{uf.label}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel id="birth_city">Cidade</InputLabel>
            <Select
              labelId="birth_city"
              id="birth_city"
              name="birth_city"
              label="Cidade"
              value={birthCity}
              error={errorValidation?.birthCity}
              onChange={e => handleOnSelectCity(e, "birth_city_id")}
            >
              {birthCities && birthCities.length > 0 ? (birthCities.map(city => (
                <MenuItem value={city.value}>{city.name_city}</MenuItem>
              )))
                : <MenuItem value={''}>{'Carregando...'}</MenuItem>}
            </Select>
          </FormControl>
        </Box>

      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button disabled={load} variant="contained" color={'success'}>
          <Typography color={'#fff'} onClick={() => handleSubmit()}>
            {load ? <CircularProgress color='success' /> : onEdit ? 'Salvar' : 'Cadastrar'}
          </Typography>
        </Button>
        <Button variant="contained" color='error' onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
